import React from "react";
import { Search, X } from "lucide-react";
import { SHEET_LABELS } from "../ExcelUploadManager";
import { SEARCH_SCOPE_OPTIONS, SEARCH_PLACEHOLDER, FACET_FILTERS } from "./constants";

// Search box ("search in" + text), dropdown filters and the schedule filter for one Excel report
export default function ExcelFilterBar({ reportType, rows, statusLabels }) {
    const { search, setSearch, searchScope, setSearchScope, rowFilter, setRowFilter, facets, setFacet, filtersActive, resetFilters } = rows;
    const optionLabel = (name, o) => (
        name === "status" ? (statusLabels[o.value] || o.value)
        : name === "sheet" ? (SHEET_LABELS[o.value] || o.value)
        : o.label ? `${o.value} — ${o.label}` : o.value
    );
    return (
        <div className="px-5 pb-3 flex items-center gap-2 flex-wrap">
            <div className="flex items-stretch bg-[#0D1520] border border-[#1F2937] rounded-lg focus-within:border-blue-500/50">
                <select value={searchScope} onChange={e => setSearchScope(e.target.value)}
                    className="bg-transparent border-r border-[#1F2937] pl-2 pr-1 text-[11px] text-slate-300 rounded-l-lg" title="Search in">
                    {SEARCH_SCOPE_OPTIONS[reportType].map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                </select>
                <div className="relative">
                    <Search size={12} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-500"/>
                    <input value={search} onChange={e => setSearch(e.target.value)}
                        placeholder={SEARCH_PLACEHOLDER[searchScope]}
                        title="Separate several values with commas to look them all up at once"
                        className="pl-7 pr-7 py-1.5 w-72 bg-transparent text-[11px] text-slate-200 placeholder:text-slate-600 outline-none"/>
                    {search && (
                        <button onClick={() => setSearch("")} className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-500 hover:text-white">
                            <X size={11}/>
                        </button>
                    )}
                </div>
            </div>
            {FACET_FILTERS[reportType].map(([name, label]) => (
                <select key={name} value={facets[name] || ""} onChange={e => setFacet(name, e.target.value)}
                    className={`py-1.5 px-2 bg-[#0D1520] border rounded-lg text-[11px] max-w-[170px] ${facets[name] ? "border-blue-500/50 text-blue-300" : "border-[#1F2937] text-slate-300"}`}>
                    <option value="">{label}: all</option>
                    {(rows.rows.options?.[name] || []).map(o => (
                        <option key={o.value} value={o.value}>{optionLabel(name, o)} ({o.count})</option>
                    ))}
                </select>
            ))}
            <select value={rowFilter} onChange={e => setRowFilter(e.target.value)}
                className={`py-1.5 px-2 bg-[#0D1520] border rounded-lg text-[11px] ${rowFilter ? "border-blue-500/50 text-blue-300" : "border-[#1F2937] text-slate-300"}`}>
                <option value="">Schedule: all</option>
                <option value="intransit">In transit</option>
                <option value="ontime">On time</option>
                <option value="delayed">Delayed</option>
                <option value="exceptions">Exceptions</option>
                <option value="noeta">{reportType === "inbound" ? "No ERD yet" : "No required date"}</option>
                <option value="delivered">Delivered</option>
            </select>
            {filtersActive && (
                <button onClick={resetFilters} className="text-[11px] text-blue-400 hover:underline">Clear filters</button>
            )}
        </div>
    );
}
